/* SOP-319: share Shopify's current, versioned swatch URLs across the React PLP. */
(() => {
  'use strict';
  const endpoint = document.currentScript.dataset.swatchUrl;
  const cache = new Map();
  const pending = new Map();
  let scheduled = false;

  async function flush() {
    scheduled = false;
    const entries = Array.from(pending.entries());
    pending.clear();
    // Keep requests small even when Graphene returns hundreds of facet values.
    for (let offset = 0; offset < entries.length; offset += 30) {
      const batch = entries.slice(offset, offset + 30);
      try {
        const url = new URL(endpoint, location.origin);
        url.searchParams.set('q', batch.map(([color]) => color).join(' '));
        const response = await fetch(url.href, { credentials: 'same-origin', cache: 'no-cache' });
        if (!response.ok) throw new Error('Swatch URL lookup failed');
        const urls = await response.json();
        batch.forEach(([color, resolve]) => {
          const value = urls[color];
          resolve(typeof value === 'string' ? value : '');
        });
      } catch (_) {
        // Keep cards usable if the lookup is temporarily unavailable.
        batch.forEach(([color, resolve]) => {
          cache.delete(color);
          resolve('/cdn/shop/files/color-' + encodeURIComponent(color) + '.png');
        });
      }
    }
  }

  window.__SOP_SWATCH_URL__ = function(color) {
    color = String(color || '').trim().toLowerCase();
    if (!color || !/^[a-z0-9-]+$/.test(color)) return Promise.resolve('');
    if (!cache.has(color)) {
      cache.set(color, new Promise(resolve => pending.set(color, resolve)));
      if (!scheduled) {
        scheduled = true;
        setTimeout(flush, 0);
      }
    }
    return cache.get(color);
  };
})();
